import { cn as e } from "../../cn.js";
import t, { barRadiusMap as n, marginMap as r, sizeMap as i } from "./styles.js";
import * as a from "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import * as c from "d3";
// src/design/charts/bar-chart/index.tsx
var l = a.createContext(null), u = () => {
	let e = a.useContext(l);
	if (!e) throw Error("BarChart compound components must be used within BarChart.Root");
	return e;
}, d = [
	"var(--color-primary-600)",
	"var(--color-green-500)",
	"var(--color-orange-500)",
	"var(--color-purple-500)",
	"var(--color-teal-500)",
	"var(--color-yellow-500)",
	"var(--color-red-500)",
	"var(--color-magenta-500)"
];
function f(e, t, n, r, i) {
	let a = Math.min(i, n / 2, Math.abs(r) / 2);
	return r === 0 ? "" : r < 0 ? `M${e},${t + r + a} Q${e},${t + r} ${e + a},${t + r} L${e + n - a},${t + r} Q${e + n},${t + r} ${e + n},${t + r + a} L${e + n},${t} L${e},${t} Z` : `M${e},${t} L${e},${t + r - a} Q${e},${t + r} ${e + a},${t + r} L${e + n - a},${t + r} Q${e + n},${t + r} ${e + n},${t + r - a} L${e + n},${t} Z`;
}
function p(e, t, n, r, i) {
	let a = Math.min(i, n / 2, Math.abs(r) / 2);
	return r === 0 ? "" : `M${e + a},${t} Q${e},${t} ${e},${t + a} L${e},${t + r} L${e + n},${t + r} L${e + n},${t + a} Q${e + n},${t} ${e + n - a},${t} Z`;
}
function m(e, t, n, r, i) {
	let a = Math.min(i, Math.abs(n) / 2, r / 2);
	return n === 0 ? "" : `M${e},${t} L${e + n - a},${t} Q${e + n},${t} ${e + n},${t + a} L${e + n},${t + r - a} Q${e + n},${t + r} ${e + n - a},${t + r} L${e},${t + r} Z`;
}
var h = a.forwardRef(({ children: t, data: s, series: u, xKey: f, config: p = {}, colors: m, className: h, animated: g = !0, grouped: _ = !1, stacked: v = !1, yMin: y, yMax: b, binCount: x = 10 }, S) => {
	let C = p.size ?? "md", w = p.variant ?? "vertical", { width: T, height: E } = i[C], D = r[C], O = n[C], k = T - D.left - D.right, A = E - D.top - D.bottom, [j, M] = a.useState({
		visible: !1,
		x: 0,
		y: 0,
		label: "",
		values: []
	}), [N, P] = a.useState(/* @__PURE__ */ new Set()), F = a.useCallback((e) => {
		P((t) => {
			let n = new Set(t);
			return n.has(e) ? n.delete(e) : n.add(e), n;
		});
	}, []), I = a.useCallback((e) => m && m[e] ? m[e] : u[e]?.color ? u[e].color : d[e % d.length], [m, u]), L = a.useMemo(() => {
		if (w !== "histogram") return;
		let e = s.map((e) => Number(e[u[0]?.key ?? f])), t = c.extent(e);
		return c.bin().domain(t).thresholds(x)(e);
	}, [
		w,
		s,
		u,
		f,
		x
	]), R = a.useMemo(() => {
		if (L) return c.scaleLinear().domain([L[0].x0 ?? 0, L[L.length - 1].x1 ?? 0]).range([0, k]);
	}, [L, k]), z = a.useMemo(() => {
		if (!L) return;
		let e = c.max(L, (e) => e.length) ?? 0;
		return c.scaleLinear().domain([0, e]).nice().range([A, 0]);
	}, [L, A]), B = a.useMemo(() => w === "histogram" ? c.scaleBand().domain([]).range([0, k]).padding(.2) : w === "horizontal" ? c.scaleBand().domain(s.map((e) => String(e[f]))).range([0, A]).padding(.2) : c.scaleBand().domain(s.map((e) => String(e[f]))).range([0, k]).padding(.2), [
		s,
		f,
		k,
		A,
		w
	]), V = a.useMemo(() => {
		if (w === "histogram") return c.scaleLinear().domain([0, 1]).range([A, 0]);
		let e = u.filter((e) => !N.has(e.key));
		if (w === "horizontal") {
			let t = s.flatMap((t) => e.map((e) => Number(t[e.key] ?? 0))), [, n] = c.extent(t), r = y ?? 0, i = b ?? n ?? 100;
			return c.scaleLinear().domain([r, i]).nice().range([0, k]);
		}
		if (v) {
			let t = c.max(s, (t) => e.reduce((e, n) => e + Math.max(0, Number(t[n.key] ?? 0)), 0)) ?? 100, n = w === "divergent" ? c.min(s, (t) => e.reduce((e, n) => e + Math.min(0, Number(t[n.key] ?? 0)), 0)) ?? 0 : 0;
			return c.scaleLinear().domain([y ?? n, b ?? t]).nice().range([A, 0]);
		}
		let t = s.flatMap((t) => e.map((e) => Number(t[e.key] ?? 0))), [n, r] = c.extent(t);
		if (w === "divergent") {
			let e = Math.max(Math.abs(n ?? 0), Math.abs(r ?? 0)), t = y ?? -e, i = b ?? e;
			return c.scaleLinear().domain([t, i]).nice().range([A, 0]);
		}
		let i = y ?? 0, a = b ?? r ?? 100, o = (a - i) * .05;
		return c.scaleLinear().domain([i, a + o]).nice().range([A, 0]);
	}, [
		s,
		u,
		N,
		k,
		A,
		y,
		b,
		w,
		v
	]), H = a.useMemo(() => ({
		data: s,
		series: u,
		xKey: f,
		config: p,
		variant: w,
		colors: I,
		width: T,
		height: E,
		margin: D,
		innerWidth: k,
		innerHeight: A,
		barRadius: O,
		xScale: B,
		yScale: V,
		tooltip: j,
		setTooltip: M,
		animated: g,
		hiddenSeries: N,
		toggleSeries: F,
		grouped: _,
		stacked: v,
		bins: L,
		histogramScale: R,
		histogramYScale: z
	}), [
		s,
		u,
		f,
		p,
		w,
		I,
		T,
		E,
		D,
		k,
		A,
		O,
		B,
		V,
		j,
		g,
		N,
		F,
		_,
		v,
		L,
		R,
		z
	]);
	return /* @__PURE__ */ o(l.Provider, {
		value: H,
		children: /* @__PURE__ */ o("div", {
			ref: S,
			className: e("relative inline-flex flex-col", h),
			children: t
		})
	});
});
h.displayName = "BarChart.Root";
var g = a.forwardRef(({ className: n, formatTick: r, label: i, tickCount: a }, l) => {
	let { xScale: d, innerHeight: f, innerWidth: p, config: m, variant: h, histogramScale: g } = u(), _ = t(m);
	if (h === "histogram" && g) {
		let t = g.ticks(a ?? 8);
		return /* @__PURE__ */ s("g", {
			ref: l,
			transform: `translate(0,${f})`,
			className: e(_.axis(), n),
			children: [
				/* @__PURE__ */ o("line", {
					x1: 0,
					x2: p,
					y1: 0,
					y2: 0,
					className: "stroke-border"
				}),
				t.map((e) => {
					let t = g(e);
					return /* @__PURE__ */ s("g", {
						transform: `translate(${t},0)`,
						children: [/* @__PURE__ */ o("line", {
							y1: 0,
							y2: 5,
							className: "stroke-border"
						}), /* @__PURE__ */ o("text", {
							y: 18,
							textAnchor: "middle",
							fill: "currentColor",
							children: r ? r(e) : String(e)
						})]
					}, e);
				}),
				i && /* @__PURE__ */ o("text", {
					x: p / 2,
					y: 36,
					textAnchor: "middle",
					fill: "currentColor",
					className: "text-muted-foreground text-xs",
					children: i
				})
			]
		});
	}
	if (h === "horizontal") {
		let t = ((e) => e.ticks(a ?? 6))(c.scaleLinear().domain(u().yScale.domain()).range([0, p]));
		return /* @__PURE__ */ s("g", {
			ref: l,
			transform: `translate(0,${f})`,
			className: e(_.axis(), n),
			children: [
				/* @__PURE__ */ o("line", {
					x1: 0,
					x2: p,
					y1: 0,
					y2: 0,
					className: "stroke-border"
				}),
				t.map((e) => {
					let t = e / u().yScale.domain()[1] * p;
					return /* @__PURE__ */ s("g", {
						transform: `translate(${t},0)`,
						children: [/* @__PURE__ */ o("line", {
							y1: 0,
							y2: 5,
							className: "stroke-border"
						}), /* @__PURE__ */ o("text", {
							y: 18,
							textAnchor: "middle",
							fill: "currentColor",
							children: r ? r(e) : String(e)
						})]
					}, e);
				}),
				i && /* @__PURE__ */ o("text", {
					x: p / 2,
					y: 36,
					textAnchor: "middle",
					fill: "currentColor",
					className: "text-muted-foreground text-xs",
					children: i
				})
			]
		});
	}
	let v = d.domain(), y = a && a < v.length ? v.filter((e, t) => t % Math.ceil(v.length / a) === 0) : v;
	return /* @__PURE__ */ s("g", {
		ref: l,
		transform: `translate(0,${f})`,
		className: e(_.axis(), n),
		children: [
			/* @__PURE__ */ o("line", {
				x1: 0,
				x2: p,
				y1: 0,
				y2: 0,
				className: "stroke-border"
			}),
			y.map((e) => {
				let t = (d(e) ?? 0) + d.bandwidth() / 2;
				return /* @__PURE__ */ s("g", {
					transform: `translate(${t},0)`,
					children: [/* @__PURE__ */ o("line", {
						y1: 0,
						y2: 5,
						className: "stroke-border"
					}), /* @__PURE__ */ o("text", {
						y: 18,
						textAnchor: "middle",
						fill: "currentColor",
						children: r ? r(e) : e
					})]
				}, e);
			}),
			i && /* @__PURE__ */ o("text", {
				x: p / 2,
				y: 36,
				textAnchor: "middle",
				fill: "currentColor",
				className: "text-muted-foreground text-xs",
				children: i
			})
		]
	});
});
g.displayName = "BarChart.XAxis";
var _ = a.forwardRef(({ className: n, tickCount: r = 5, formatTick: i, label: a }, c) => {
	let { yScale: l, xScale: d, innerHeight: f, config: p, variant: m, histogramYScale: h } = u(), g = t(p);
	if (m === "histogram" && h) {
		let t = h.ticks(r);
		return /* @__PURE__ */ s("g", {
			ref: c,
			className: e(g.axis(), n),
			children: [t.map((e) => /* @__PURE__ */ s("g", {
				transform: `translate(0,${h(e)})`,
				children: [/* @__PURE__ */ o("line", {
					x1: -5,
					x2: 0,
					className: "stroke-border"
				}), /* @__PURE__ */ o("text", {
					x: -10,
					textAnchor: "end",
					dominantBaseline: "middle",
					fill: "currentColor",
					children: i ? i(e) : String(e)
				})]
			}, e)), a && /* @__PURE__ */ o("text", {
				transform: `translate(-38,${f / 2}) rotate(-90)`,
				textAnchor: "middle",
				fill: "currentColor",
				className: "text-muted-foreground text-xs",
				children: a
			})]
		});
	}
	if (m === "horizontal") {
		let t = d.domain();
		return /* @__PURE__ */ s("g", {
			ref: c,
			className: e(g.axis(), n),
			children: [t.map((e) => {
				let t = (d(e) ?? 0) + d.bandwidth() / 2;
				return /* @__PURE__ */ s("g", {
					transform: `translate(0,${t})`,
					children: [/* @__PURE__ */ o("line", {
						x1: -5,
						x2: 0,
						className: "stroke-border"
					}), /* @__PURE__ */ o("text", {
						x: -10,
						textAnchor: "end",
						dominantBaseline: "middle",
						fill: "currentColor",
						children: i ? i(e) : e
					})]
				}, e);
			}), a && /* @__PURE__ */ o("text", {
				transform: `translate(-38,${f / 2}) rotate(-90)`,
				textAnchor: "middle",
				fill: "currentColor",
				className: "text-muted-foreground text-xs",
				children: a
			})]
		});
	}
	let _ = l.ticks(r);
	return /* @__PURE__ */ s("g", {
		ref: c,
		className: e(g.axis(), n),
		children: [_.map((e) => /* @__PURE__ */ s("g", {
			transform: `translate(0,${l(e)})`,
			children: [/* @__PURE__ */ o("line", {
				x1: -5,
				x2: 0,
				className: "stroke-border"
			}), /* @__PURE__ */ o("text", {
				x: -10,
				textAnchor: "end",
				dominantBaseline: "middle",
				fill: "currentColor",
				children: i ? i(e) : String(e)
			})]
		}, e)), a && /* @__PURE__ */ o("text", {
			transform: `translate(-38,${f / 2}) rotate(-90)`,
			textAnchor: "middle",
			fill: "currentColor",
			className: "text-muted-foreground text-xs",
			children: a
		})]
	});
});
_.displayName = "BarChart.YAxis";
var v = a.forwardRef(({ className: n, horizontal: r = !0, vertical: i = !1, tickCount: a = 5 }, c) => {
	let { yScale: l, innerWidth: d, config: f, variant: p, histogramYScale: m } = u(), h = t(f), g = p === "histogram" && m ? m.ticks(a) : l.ticks(a), _ = p === "histogram" && m ? m : l;
	return /* @__PURE__ */ s("g", {
		ref: c,
		className: e(h.grid(), n),
		children: [r && g.map((e) => /* @__PURE__ */ o("line", {
			x1: 0,
			x2: d,
			y1: _(e),
			y2: _(e),
			strokeDasharray: "3 3"
		}, `h-${e}`)), i && p === "divergent" && /* @__PURE__ */ o("line", {
			x1: 0,
			x2: d,
			y1: l(0),
			y2: l(0),
			className: "stroke-muted-foreground",
			strokeWidth: 1
		})]
	});
});
v.displayName = "BarChart.Grid";
var y = a.forwardRef(({ className: t }, n) => {
	let { yScale: r, innerWidth: i, variant: a } = u();
	if (a !== "divergent") return null;
	let s = r(0);
	return /* @__PURE__ */ o("line", {
		ref: n,
		x1: 0,
		x2: i,
		y1: s,
		y2: s,
		className: e("stroke-foreground opacity-60", t),
		strokeWidth: 1
	});
});
y.displayName = "BarChart.ZeroLine";
var b = a.forwardRef(({ className: e, onBarHover: t, onBarClick: n }, r) => {
	let { data: i, series: s, xKey: c, xScale: l, yScale: d, colors: h, innerHeight: g, barRadius: _, animated: v, hiddenSeries: y, setTooltip: b, variant: x, grouped: S, stacked: C, bins: w, histogramScale: T, histogramYScale: E } = u(), D = a.useMemo(() => s.filter((e) => !y.has(e.key)), [s, y]), O = a.useCallback((e, t, n) => {
		let r = e.currentTarget.closest("svg")?.getBoundingClientRect();
		r && b({
			visible: !0,
			x: e.clientX - r.left,
			y: e.clientY - r.top,
			label: t,
			values: n
		});
	}, [b]), k = a.useCallback((e) => {
		let t = e.currentTarget.closest("svg")?.getBoundingClientRect();
		t && b((n) => ({
			...n,
			x: e.clientX - t.left,
			y: e.clientY - t.top
		}));
	}, [b]), A = a.useCallback(() => {
		b({
			visible: !1,
			x: 0,
			y: 0,
			label: "",
			values: []
		});
	}, [b]);
	if (x === "histogram" && w && T && E) {
		let t = h(0);
		return /* @__PURE__ */ o("g", {
			ref: r,
			className: e,
			children: w.map((e, n) => {
				let r = T(e.x0 ?? 0), i = T(e.x1 ?? 0) - r - 1, a = E(e.length), s = g - a;
				return i <= 0 || s <= 0 ? null : /* @__PURE__ */ o("path", {
					d: p(r, a, Math.max(i, 0), s, _),
					fill: t,
					className: "transition-opacity duration-normal hover:opacity-80 cursor-pointer",
					onMouseEnter: (n) => O(n, `${e.x0?.toFixed(1)} – ${e.x1?.toFixed(1)}`, [{
						key: "Count",
						value: e.length,
						color: t
					}]),
					onMouseMove: k,
					onMouseLeave: A,
					style: v ? { animation: `bar-chart-grow-up 0.5s ease-enter ${n * .03}s both` } : void 0
				}, n);
			})
		});
	}
	if (x === "horizontal") return /* @__PURE__ */ o("g", {
		ref: r,
		className: e,
		children: i.map((e, r) => {
			let i = l(String(e[c])) ?? 0, a = l.bandwidth(), u = S ? a / D.length : a;
			return D.map((a, l) => {
				let f = Number(e[a.key] ?? 0), p = d(f), g = S ? i + l * u : i, y = h(s.indexOf(a));
				return /* @__PURE__ */ o("path", {
					d: m(0, g, p, S ? u - 1 : u, _),
					fill: y,
					className: "transition-opacity duration-normal hover:opacity-80 cursor-pointer",
					onMouseEnter: (t) => O(t, String(e[c]), [{
						key: a.label ?? a.key,
						value: f,
						color: y
					}]),
					onMouseMove: k,
					onMouseLeave: () => {
						A(), t?.(null, a.key, r);
					},
					onClick: () => n?.(e, a.key, r),
					style: v ? { animation: `bar-chart-grow-right 0.5s ease-enter ${r * .04 + l * .02}s both` } : void 0
				}, `${r}-${a.key}`);
			});
		})
	});
	if (x === "divergent") {
		let a = d(0);
		return /* @__PURE__ */ o("g", {
			ref: r,
			className: e,
			children: i.map((e, r) => {
				let i = l(String(e[c])) ?? 0, u = l.bandwidth(), m = S ? u / D.length : u;
				return D.map((l, u) => {
					let g = Number(e[l.key] ?? 0), y = d(g), b = S ? i + u * m : i, x = h(s.indexOf(l)), C = g >= 0, w = C ? y : a, T = Math.abs(y - a), E = C ? p(b, w, S ? m - 1 : m, T, _) : f(b, w, S ? m - 1 : m, T, _);
					return /* @__PURE__ */ o("path", {
						d: E,
						fill: x,
						className: "transition-opacity duration-normal hover:opacity-80 cursor-pointer",
						onMouseEnter: (t) => O(t, String(e[c]), [{
							key: l.label ?? l.key,
							value: g,
							color: x
						}]),
						onMouseMove: k,
						onMouseLeave: () => {
							A(), t?.(null, l.key, r);
						},
						onClick: () => n?.(e, l.key, r),
						style: v ? { animation: `bar-chart-grow-up 0.5s ease-enter ${r * .04 + u * .02}s both` } : void 0
					}, `${r}-${l.key}`);
				});
			})
		});
	}
	return C ? /* @__PURE__ */ o("g", {
		ref: r,
		className: e,
		children: i.map((e, r) => {
			let i = l(String(e[c])) ?? 0, a = l.bandwidth(), u = g;
			return D.map((l, f) => {
				let m = Number(e[l.key] ?? 0), y = g - d(m), b = u - y;
				u = b;
				let x = h(s.indexOf(l)), S = f === D.length - 1;
				return /* @__PURE__ */ o("path", {
					d: S ? p(i, b, a, y, _) : `M${i},${b} L${i + a},${b} L${i + a},${b + y} L${i},${b + y} Z`,
					fill: x,
					className: "transition-opacity duration-normal hover:opacity-80 cursor-pointer",
					onMouseEnter: (t) => O(t, String(e[c]), [{
						key: l.label ?? l.key,
						value: m,
						color: x
					}]),
					onMouseMove: k,
					onMouseLeave: () => {
						A(), t?.(null, l.key, r);
					},
					onClick: () => n?.(e, l.key, r),
					style: v ? { animation: `bar-chart-grow-up 0.5s ease-enter ${r * .04 + f * .02}s both` } : void 0
				}, `${r}-${l.key}`);
			});
		})
	}) : /* @__PURE__ */ o("g", {
		ref: r,
		className: e,
		children: i.map((e, r) => {
			let i = l(String(e[c])) ?? 0, a = l.bandwidth(), u = S || D.length > 1 ? a / D.length : a;
			return D.map((a, l) => {
				let f = Number(e[a.key] ?? 0), m = d(f), y = g - m, b = S || D.length > 1 ? i + l * u : i, x = h(s.indexOf(a));
				return /* @__PURE__ */ o("path", {
					d: p(b, m, S || D.length > 1 ? u - 1 : u, y, _),
					fill: x,
					className: "transition-opacity duration-normal hover:opacity-80 cursor-pointer",
					onMouseEnter: (t) => O(t, String(e[c]), [{
						key: a.label ?? a.key,
						value: f,
						color: x
					}]),
					onMouseMove: k,
					onMouseLeave: () => {
						A(), t?.(null, a.key, r);
					},
					onClick: () => n?.(e, a.key, r),
					style: v ? { animation: `bar-chart-grow-up 0.5s ease-enter ${r * .04 + l * .02}s both` } : void 0
				}, `${r}-${a.key}`);
			});
		})
	});
});
b.displayName = "BarChart.Bars";
var x = a.forwardRef(({ children: e, className: t }, n) => {
	let { width: r, height: i, margin: a } = u();
	return /* @__PURE__ */ s("svg", {
		ref: n,
		width: r,
		height: i,
		viewBox: `0 0 ${r} ${i}`,
		className: t,
		children: [/* @__PURE__ */ o("defs", { children: /* @__PURE__ */ o("style", { children: "\n                        @keyframes bar-chart-grow-up {\n                            from { opacity: 0; transform: scaleY(0); transform-origin: bottom; }\n                            to { opacity: 1; transform: scaleY(1); transform-origin: bottom; }\n                        }\n                        @keyframes bar-chart-grow-right {\n                            from { opacity: 0; transform: scaleX(0); transform-origin: left; }\n                            to { opacity: 1; transform: scaleX(1); transform-origin: left; }\n                        }\n                    " }) }), /* @__PURE__ */ o("g", {
			transform: `translate(${a.left},${a.top})`,
			children: e
		})]
	});
});
x.displayName = "BarChart.ChartSvg";
var S = a.forwardRef(({ className: n, position: r = "bottom", interactive: i = !0 }, a) => {
	let { series: c, colors: l, config: d, hiddenSeries: f, toggleSeries: p } = u(), m = t(d);
	return /* @__PURE__ */ o("div", {
		ref: a,
		className: e(m.legend(r), n),
		children: c.map((t, n) => {
			let r = l(n), a = f.has(t.key);
			return /* @__PURE__ */ s("div", {
				className: e(m.legendItem(), a && "opacity-40 line-through"),
				onClick: i ? () => p(t.key) : void 0,
				role: i ? "button" : void 0,
				tabIndex: i ? 0 : void 0,
				onKeyDown: i ? (e) => {
					(e.key === "Enter" || e.key === " ") && (e.preventDefault(), p(t.key));
				} : void 0,
				children: [/* @__PURE__ */ o("span", {
					className: m.legendDot(),
					style: { backgroundColor: r }
				}), /* @__PURE__ */ o("span", { children: t.label ?? t.key })]
			}, t.key);
		})
	});
});
S.displayName = "BarChart.Legend";
var C = a.forwardRef(({ className: n, renderContent: r }, i) => {
	let { tooltip: a, config: c } = u(), l = t(c);
	return a.visible ? /* @__PURE__ */ o("div", {
		ref: i,
		className: e(l.tooltip(), n),
		style: {
			left: a.x + 12,
			top: a.y - 8,
			opacity: +!!a.visible
		},
		children: r ? r(a.label, a.values) : /* @__PURE__ */ s("div", {
			className: "flex flex-col gap-1.5",
			children: [/* @__PURE__ */ o("span", {
				className: "font-semibold border-b border-background/20 pb-1",
				children: a.label
			}), a.values.map((e) => /* @__PURE__ */ s("div", {
				className: l.tooltipRow(),
				children: [/* @__PURE__ */ o("span", {
					className: "w-2 h-2 rounded-full shrink-0",
					style: { backgroundColor: e.color }
				}), /* @__PURE__ */ s("span", { children: [
					e.key,
					": ",
					e.value
				] })]
			}, e.key))]
		})
	}) : null;
});
C.displayName = "BarChart.Tooltip";
var w = a.forwardRef(({ showGrid: e = !0, showXAxis: t = !0, showYAxis: n = !0, showLegend: r = !0, legendPosition: i = "bottom", showTooltip: a = !0, showZeroLine: c = !0, tooltipRenderer: l, xAxisLabel: u, yAxisLabel: d, formatXTick: f, formatYTick: p, yTickCount: m, xTickCount: w, ...T }, E) => {
	let D = i === "right" ? "inline-flex flex-row items-start" : "inline-flex flex-col items-center";
	return /* @__PURE__ */ o(h, {
		ref: E,
		...T,
		children: /* @__PURE__ */ s("div", {
			className: D,
			children: [/* @__PURE__ */ s("div", {
				className: "relative",
				children: [/* @__PURE__ */ s(x, { children: [
					e && /* @__PURE__ */ o(v, {
						horizontal: !0,
						vertical: !1,
						tickCount: m
					}),
					t && /* @__PURE__ */ o(g, {
						label: u,
						formatTick: f,
						tickCount: w
					}),
					n && /* @__PURE__ */ o(_, {
						label: d,
						formatTick: p,
						tickCount: m
					}),
					c && /* @__PURE__ */ o(y, {}),
					/* @__PURE__ */ o(b, {})
				] }), a && /* @__PURE__ */ o(C, { renderContent: l })]
			}), r && T.series.length > 1 && /* @__PURE__ */ o(S, { position: i })]
		})
	});
});
w.displayName = "BarChart";
var T = Object.assign(w, {
	Default: w,
	Root: h,
	ChartSvg: x,
	XAxis: g,
	YAxis: _,
	Grid: v,
	ZeroLine: y,
	Bars: b,
	Legend: S,
	Tooltip: C,
	getStyles: t
});
export { T as BarChart, T as default, u as useBarChart };

//# sourceMappingURL=index.js.map